import React, { useContext } from "react";
import TeamInfoCard from "../components/TeamInfoCard";
import { InfoContext } from "../components/InfoContext";

const Teams: React.FC = () => {
  const { teams } = useContext(InfoContext);
  return (
    <div className="p-4">
      <h1 className="text-3xl font-bold mb-6 mt-4 text-center text-white">
        Teams
      </h1>
      <div className="flex flex-wrap justify-center gap-4">
        {teams
          .filter((team) => team.is_active)
          .sort((a,b) => b.player_count - a.player_count)
          .map((team) => (
            <TeamInfoCard team={team} key={team.team_id} />
          ))}
      </div>
    </div>
  );
};

export default Teams;
